module.exports = new __parcel__URL__("artifact_0004.3803de42.png").toString();